import $ from 'jquery';
import { spin } from './_site';
import { validatefields } from './form';
import { axiosEditPlacedOrder } from '../actions/orderActions';
import { handleAxiosErrors } from '../_utils';

export const timeout = {};
export const send = ($el) => {
    var $submit = $el,
        $submitAux = $submit.children('span'),
        submitClass = 'form__submit',
        spinner = $.extend(true, {}, spin);

    // spinner.color = '#d1b584';
    spinner.color = '#000000';

    function toggleLoader(flag) {
        if (flag) {
            // add loader
            $submit.addClass(submitClass + '--loading');
            $submitAux.spin(spinner);
        } else {
            // remove loader
            $submit.removeClass(submitClass + '--loading');
            $submitAux.spin(false);
        }
    }

    // prevent multiple clicks
    if (
        $submit.hasClass(submitClass + '--loading') ||
        $submit.hasClass('button--disabled')
    ) {
        return false;
    }

    // send data
    toggleLoader(true);

    axiosEditPlacedOrder(0).then((response) => {

        if(response.data.data.editPlacedOrder !== undefined) {
            window.location.reload();
        }

    }).catch((error) => {
        handleAxiosErrors(error);
    }).then(() => {
        toggleLoader(false);
    });
};
export const binds = () => {
    // ---------------- login
    $('body').on('click', '[data-cancel-edit-order]', function(event) {
        event.preventDefault();
        send($(this));
    });
};
